import { FC, InputHTMLAttributes, SyntheticEvent } from 'react';

import Checkbox from '~src/shared/form/Checkbox';
import { HeaderContainer } from '~src/modules/surveys/components/schedules/scheduleItem/templates/scheduleTemplate.sc';
import { translateContent } from '~src/services/translationServices';
import SvgIcon from '~src/shared/SvgIcon';
import HoverInfoIcon from '~src/shared/tooltips/HoverInfoIcon';
import { Question } from '~src/interfaces/question.interface';
import UrlText from '~src/shared/UrlText';

import { IconMargin, QuestionText, Toggle, PenIcon } from './topicQuestions.sc';

interface Props {
  input: InputHTMLAttributes<any>;
  question: Question;
  editThisQuestion: (questionId: string, e: SyntheticEvent) => void;
  onEdit?: (value: string | null, question: Question) => Promise<{}>;
  onChange: (e: SyntheticEvent) => void;
}

const QuestionItem: FC<Props> = ({ question, input, editThisQuestion, onEdit, onChange }) => {
  const clickThisQuestion = (e: SyntheticEvent) => {
    editThisQuestion(question.id, e);
  };

  return (
    <Toggle id={question.id} key={question.id} htmlFor={question.id} onClick={onChange}>
      <Checkbox id={question.id} val={question.id} input={input} isChecked={!!input.checked} />
      <QuestionText>
        <HeaderContainer>
          <UrlText blocked text={translateContent(question.title)} />
          <IconMargin>
            {onEdit ? (
              <PenIcon onClick={clickThisQuestion}>
                <SvgIcon width="20px" name="iconPen" />
              </PenIcon>
            ) : (
              question.description &&
              translateContent(question.description) && (
                <HoverInfoIcon infoText={translateContent(question.description)} />
              )
            )}
          </IconMargin>
        </HeaderContainer>
      </QuestionText>
    </Toggle>
  );
};

export default QuestionItem;
